var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaveShareMixIphoneMessageIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 106.68 106.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#\xE5\xE7\xFB\xEC\xDF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_35);}.cls-2{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xE5\\xE7\\xFB\\xEC\\xDF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_35",
    x1: 53.34,
    y1: 106.68,
    x2: 53.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#1abc2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#1bbd2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#3bdc58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#4ff072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56f77c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_18",
    "data-name": "Layer 18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 106.68,
    height: 106.68,
    rx: 53.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.43,25.21C35,25.21,20.94,37,20.94,51.57c0,9.16,5.58,17.23,14.05,21.95a2,2,0,0,1,.93,2.41,11,11,0,0,1-4.3,5.46s3.79,1,11.81-3.86a2.55,2.55,0,0,1,1.81-.3,36.76,36.76,0,0,0,7.19.7c17.39,0,31.49-11.8,31.49-26.36S69.82,25.21,52.43,25.21Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveShareMixIphoneMessageIcon);
export default __webpack_public_path__ + "static/media/SaveShareMixIphoneMessageIcon.8e76a4092da7d8647c817ff293b36c02.svg";
export { ForwardRef as ReactComponent };